<template>
    <div class="container data">
        <h3>{{ $translate('card_opening_hours_h3', 'Öppettider') }}</h3>
        <ul class="custom-list">
            <li
                v-for="(day, index) in openingHours"
                :key="index"
            >
                <span>{{ capitalize(day.text) }}</span>
                <span v-if="day.value">{{ day.value }}</span>
                <span v-else>-</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { capitalize } from 'lodash';
export default {
    props: {
        document: {
            type: Object,
            required: true,
        },
        model: {
            type: Object,
            required: true,
        }
    },
    computed: {
        openingHours() {
            return [
                {
                    text: this.$translate('monday', 'Måndag'),
                    value: this.model.openingHours.monday
                },
                {
                    text: this.$translate('tuesday', 'Tisdag'),
                    value: this.model.openingHours.tuesday
                },
                {
                    text: this.$translate('wednesday', 'Onsdag'),
                    value: this.model.openingHours.wednesday
                },
                {
                    text: this.$translate('thursday', 'Torsdag'),
                    value: this.model.openingHours.thursday
                },
                {
                    text: this.$translate('friday', 'Fredag'),
                    value: this.model.openingHours.friday
                },
                {
                    text: this.$translate('saturday', 'Lördag'),
                    value: this.model.openingHours.saturday
                },
                {
                    text: this.$translate('sunday', 'Söndag'),
                    value: this.model.openingHours.sunday
                }
            ];
        }
    },
    methods: {
        capitalize(text) {
            return capitalize(text);
        }
    }
};
</script>
